import type { SortItem, SortEvent, SortAlgorithm } from '@/core/types';
import { EventRecorderImpl } from '@/core/EventRecorderImpl';

export class BubbleSort implements SortAlgorithm {
  readonly name = 'Bubble Sort';
  readonly category = 'comparison' as const;
  readonly stable = true;
  readonly inPlace = true;
  readonly adaptive = true;
  readonly best = 'O(n) - with swapped flag for already sorted data';
  readonly average = 'O(n^2) - average case comparisons';
  readonly worst = 'O(n^2) - reversed sorted data (worst-case)';
  readonly space = 'O(1) - in-place swapping';

  run(input: SortItem[]): SortEvent[] {
    const recorder = new EventRecorderImpl();
    const arr = input.map(item => ({ ...item }));
    const n = arr.length;

    for (let i = 0; i < n - 1; i++) {
      let swapped = false;
      for (let j = 0; j < n - i - 1; j++) {
        recorder.record({ type: 'compare', indices: [j, j + 1] });
        if (arr[j].value > arr[j + 1].value) {
          recorder.record({ type: 'swap', indices: [j, j + 1] });
          const tmp = arr[j]; arr[j] = arr[j + 1]; arr[j + 1] = tmp;
          arr[j].currentIndex = j; arr[j + 1].currentIndex = j + 1;
          swapped = true;
        }
      }
      if (!swapped) break;
    }

    recorder.record({ type: 'done', indices: arr.map((_, i) => i) });
    return recorder.events;
  }
}
